// Language translations for MoodPunk
export const translations = {
  es: {
    // Login Page
    login: {
      title: "MOODPUNK",
      subtitle: "Tu compañero de bienestar emocional",
      incognito: "MODO INCÓGNITO",
      incognitoDesc: "Sin registro, datos locales",
      google: "GOOGLE",
      googleDesc: "Sincroniza entre dispositivos",
      moodpunk: "MOODPUNK",
      moodpunkDesc: "Crea tu cuenta única",
      or: "o inicia sesión con",
      email: "Email",
      password: "Contraseña",
      name: "Nombre",
      login: "Iniciar Sesión",
      register: "Registrarse",
      noAccount: "¿No tienes cuenta?",
      hasAccount: "¿Ya tienes cuenta?",
      createAccount: "Crear cuenta",
      loginHere: "Inicia sesión aquí",
      selectLanguage: "Selecciona tu idioma",
      usersJoined: "usuarios registrados",
    },
    // Dashboard
    dashboard: {
      howFeeling: "¿Cómo te sientes ahora mismo?",
      sync: "Sincronizar",
      syncing: "Sincronizando...",
      recentMoods: "Registros Recientes",
      noMoods: "No hay registros aún",
      addNote: "Añadir una nota (opcional)...",
      save: "Guardar",
      delete: "Eliminar",
      share: "Compartir",
    },
    // Navigation
    nav: {
      dashboard: "Dashboard",
      chat: "Chat",
      calendar: "Calendario",
      stats: "Estadísticas",
      export: "Exportar",
      profile: "Perfil",
      logout: "Cerrar Sesión",
    },
    // Moods
    moods: {
      very_happy: "Muy Feliz",
      happy: "Bien",
      neutral: "Neutral",
      sad: "Triste",
      very_sad: "Muy Triste",
      angry: "Enojado",
      anxious: "Ansioso",
      tired: "Cansado",
      in_love: "Enamorado",
      sick: "Enfermo",
      surprised: "Sorprendido",
      relaxed: "Relajado",
      sporty: "Deportista",
      forgiven: "Perdonado",
    },
    // Stats
    stats: {
      totalEntries: "Total Registros",
      averageMood: "Promedio",
      currentStreak: "Racha Actual",
      mostCommon: "Más Frecuente",
      days: "días",
    },
    // Chat
    chat: {
      searchUsers: "Buscar usuarios...",
      noConversations: "No tienes conversaciones aún",
      startChat: "Busca usuarios para empezar a chatear",
      typeMessage: "Escribe un mensaje...",
      notAvailable: "Chat no disponible en modo incógnito",
      loginRequired: "Inicia sesión con Google o MoodPunk para chatear",
    },
    // AI Chatbot
    chatbot: {
      greeting: "¡Hola! Soy MoodBot, tu asistente de bienestar emocional. ¿Cómo te sientes hoy? Estoy aquí para escucharte.",
      suggestion1: "Me siento bien",
      suggestion2: "Necesito hablar",
      suggestion3: "¿Qué puedes hacer?",
      typing: "MoodBot está escribiendo...",
      placeholder: "Escribe un mensaje...",
      clearHistory: "Historial limpiado",
      assistant: "Tu asistente emocional",
    },
    // Common
    common: {
      loading: "Cargando...",
      error: "Error",
      success: "Éxito",
      cancel: "Cancelar",
      confirm: "Confirmar",
      save: "Guardar",
      delete: "Eliminar",
      edit: "Editar",
      close: "Cerrar",
      today: "Hoy",
      yesterday: "Ayer",
      now: "Ahora",
    },
  },
  
  en: {
    login: {
      title: "MOODPUNK",
      subtitle: "Your emotional wellness companion",
      incognito: "INCOGNITO MODE",
      incognitoDesc: "No registration, local data",
      google: "GOOGLE",
      googleDesc: "Sync across devices",
      moodpunk: "MOODPUNK",
      moodpunkDesc: "Create your unique account",
      or: "or login with",
      email: "Email",
      password: "Password",
      name: "Name",
      login: "Login",
      register: "Register",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      createAccount: "Create account",
      loginHere: "Login here",
      selectLanguage: "Select your language",
      usersJoined: "users joined",
    },
    dashboard: {
      howFeeling: "How are you feeling right now?",
      sync: "Sync",
      syncing: "Syncing...",
      recentMoods: "Recent Entries",
      noMoods: "No entries yet",
      addNote: "Add a note (optional)...",
      save: "Save",
      delete: "Delete",
      share: "Share",
    },
    nav: {
      dashboard: "Dashboard",
      chat: "Chat",
      calendar: "Calendar",
      stats: "Statistics",
      export: "Export",
      profile: "Profile",
      logout: "Logout",
    },
    moods: {
      very_happy: "Very Happy",
      happy: "Good",
      neutral: "Neutral",
      sad: "Sad",
      very_sad: "Very Sad",
      angry: "Angry",
      anxious: "Anxious",
      tired: "Tired",
      in_love: "In Love",
      sick: "Sick",
      surprised: "Surprised",
      relaxed: "Relaxed",
      sporty: "Sporty",
      forgiven: "Forgiven",
    },
    stats: {
      totalEntries: "Total Entries",
      averageMood: "Average",
      currentStreak: "Current Streak",
      mostCommon: "Most Common",
      days: "days",
    },
    chat: {
      searchUsers: "Search users...",
      noConversations: "No conversations yet",
      startChat: "Search users to start chatting",
      typeMessage: "Type a message...",
      notAvailable: "Chat not available in incognito mode",
      loginRequired: "Login with Google or MoodPunk to chat",
    },
    chatbot: {
      greeting: "Hello! I'm MoodBot, your emotional wellness assistant. How are you feeling today? I'm here to listen.",
      suggestion1: "I feel good",
      suggestion2: "I need to talk",
      suggestion3: "What can you do?",
      typing: "MoodBot is typing...",
      placeholder: "Type a message...",
      clearHistory: "History cleared",
      assistant: "Your emotional assistant",
    },
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success",
      cancel: "Cancel",
      confirm: "Confirm",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      close: "Close",
      today: "Today",
      yesterday: "Yesterday",
      now: "Now",
    },
  },
  
  fr: {
    login: {
      title: "MOODPUNK",
      subtitle: "Votre compagnon de bien-être émotionnel",
      incognito: "MODE INCOGNITO",
      incognitoDesc: "Sans inscription, données locales",
      google: "GOOGLE",
      googleDesc: "Synchroniser entre appareils",
      moodpunk: "MOODPUNK",
      moodpunkDesc: "Créez votre compte unique",
      or: "ou connectez-vous avec",
      email: "Email",
      password: "Mot de passe",
      name: "Nom",
      login: "Connexion",
      register: "S'inscrire",
      noAccount: "Pas de compte ?",
      hasAccount: "Déjà un compte ?",
      createAccount: "Créer un compte",
      loginHere: "Connectez-vous ici",
      selectLanguage: "Sélectionnez votre langue",
      usersJoined: "utilisateurs inscrits",
    },
    dashboard: {
      howFeeling: "Comment vous sentez-vous maintenant ?",
      sync: "Synchroniser",
      syncing: "Synchronisation...",
      recentMoods: "Entrées Récentes",
      noMoods: "Pas encore d'entrées",
      addNote: "Ajouter une note (optionnel)...",
      save: "Enregistrer",
      delete: "Supprimer",
      share: "Partager",
    },
    nav: {
      dashboard: "Tableau de bord",
      chat: "Chat",
      calendar: "Calendrier",
      stats: "Statistiques",
      export: "Exporter",
      profile: "Profil",
      logout: "Déconnexion",
    },
    moods: {
      very_happy: "Très Heureux",
      happy: "Bien",
      neutral: "Neutre",
      sad: "Triste",
      very_sad: "Très Triste",
      angry: "En Colère",
      anxious: "Anxieux",
      tired: "Fatigué",
      in_love: "Amoureux",
      sick: "Malade",
      surprised: "Surpris",
      relaxed: "Détendu",
      sporty: "Sportif",
      forgiven: "Pardonné",
    },
    stats: {
      totalEntries: "Total Entrées",
      averageMood: "Moyenne",
      currentStreak: "Série Actuelle",
      mostCommon: "Plus Fréquent",
      days: "jours",
    },
    chat: {
      searchUsers: "Rechercher des utilisateurs...",
      noConversations: "Pas encore de conversations",
      startChat: "Recherchez des utilisateurs pour commencer",
      typeMessage: "Écrivez un message...",
      notAvailable: "Chat non disponible en mode incognito",
      loginRequired: "Connectez-vous avec Google ou MoodPunk pour chatter",
    },
    chatbot: {
      greeting: "Bonjour ! Je suis MoodBot, votre assistant de bien-être émotionnel. Comment vous sentez-vous aujourd'hui ? Je suis là pour vous écouter.",
      suggestion1: "Je me sens bien",
      suggestion2: "J'ai besoin de parler",
      suggestion3: "Que peux-tu faire ?",
      typing: "MoodBot écrit...",
      placeholder: "Écrivez un message...",
      clearHistory: "Historique effacé",
      assistant: "Votre assistant émotionnel",
    },
    common: {
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      cancel: "Annuler",
      confirm: "Confirmer",
      save: "Enregistrer",
      delete: "Supprimer",
      edit: "Modifier",
      close: "Fermer",
      today: "Aujourd'hui",
      yesterday: "Hier",
      now: "Maintenant",
    },
  },
  
  de: {
    login: {
      title: "MOODPUNK",
      subtitle: "Ihr emotionaler Wellness-Begleiter",
      incognito: "INKOGNITO-MODUS",
      incognitoDesc: "Ohne Registrierung, lokale Daten",
      google: "GOOGLE",
      googleDesc: "Geräteübergreifend synchronisieren",
      moodpunk: "MOODPUNK",
      moodpunkDesc: "Erstellen Sie Ihr einzigartiges Konto",
      or: "oder anmelden mit",
      email: "E-Mail",
      password: "Passwort",
      name: "Name",
      login: "Anmelden",
      register: "Registrieren",
      noAccount: "Kein Konto?",
      hasAccount: "Bereits ein Konto?",
      createAccount: "Konto erstellen",
      loginHere: "Hier anmelden",
      selectLanguage: "Wählen Sie Ihre Sprache",
      usersJoined: "registrierte Benutzer",
    },
    dashboard: {
      howFeeling: "Wie fühlen Sie sich gerade?",
      sync: "Synchronisieren",
      syncing: "Synchronisiere...",
      recentMoods: "Letzte Einträge",
      noMoods: "Noch keine Einträge",
      addNote: "Notiz hinzufügen (optional)...",
      save: "Speichern",
      delete: "Löschen",
      share: "Teilen",
    },
    nav: {
      dashboard: "Dashboard",
      chat: "Chat",
      calendar: "Kalender",
      stats: "Statistiken",
      export: "Exportieren",
      profile: "Profil",
      logout: "Abmelden",
    },
    moods: {
      very_happy: "Sehr Glücklich",
      happy: "Gut",
      neutral: "Neutral",
      sad: "Traurig",
      very_sad: "Sehr Traurig",
      angry: "Wütend",
      anxious: "Ängstlich",
      tired: "Müde",
      in_love: "Verliebt",
      sick: "Krank",
      surprised: "Überrascht",
      relaxed: "Entspannt",
      sporty: "Sportlich",
      forgiven: "Vergeben",
    },
    stats: {
      totalEntries: "Gesamteinträge",
      averageMood: "Durchschnitt",
      currentStreak: "Aktuelle Serie",
      mostCommon: "Am Häufigsten",
      days: "Tage",
    },
    chat: {
      searchUsers: "Benutzer suchen...",
      noConversations: "Noch keine Gespräche",
      startChat: "Suchen Sie Benutzer zum Chatten",
      typeMessage: "Nachricht schreiben...",
      notAvailable: "Chat im Inkognito-Modus nicht verfügbar",
      loginRequired: "Mit Google oder MoodPunk anmelden zum Chatten",
    },
    chatbot: {
      greeting: "Hallo! Ich bin MoodBot, Ihr emotionaler Wellness-Assistent. Wie fühlen Sie sich heute? Ich bin hier, um zuzuhören.",
      suggestion1: "Mir geht es gut",
      suggestion2: "Ich muss reden",
      suggestion3: "Was kannst du tun?",
      typing: "MoodBot schreibt...",
      placeholder: "Nachricht schreiben...",
      clearHistory: "Verlauf gelöscht",
      assistant: "Ihr emotionaler Assistent",
    },
    common: {
      loading: "Laden...",
      error: "Fehler",
      success: "Erfolg",
      cancel: "Abbrechen",
      confirm: "Bestätigen",
      save: "Speichern",
      delete: "Löschen",
      edit: "Bearbeiten",
      close: "Schließen",
      today: "Heute",
      yesterday: "Gestern",
      now: "Jetzt",
    },
  },
  
  zh: {
    login: {
      title: "MOODPUNK",
      subtitle: "您的情绪健康伙伴",
      incognito: "隐身模式",
      incognitoDesc: "无需注册，本地数据",
      google: "谷歌",
      googleDesc: "跨设备同步",
      moodpunk: "MOODPUNK",
      moodpunkDesc: "创建您的专属账户",
      or: "或使用以下方式登录",
      email: "邮箱",
      password: "密码",
      name: "姓名",
      login: "登录",
      register: "注册",
      noAccount: "没有账户？",
      hasAccount: "已有账户？",
      createAccount: "创建账户",
      loginHere: "在此登录",
      selectLanguage: "选择您的语言",
      usersJoined: "位用户已加入",
    },
    dashboard: {
      howFeeling: "您现在感觉如何？",
      sync: "同步",
      syncing: "同步中...",
      recentMoods: "最近记录",
      noMoods: "暂无记录",
      addNote: "添加备注（可选）...",
      save: "保存",
      delete: "删除",
      share: "分享",
    },
    nav: {
      dashboard: "仪表板",
      chat: "聊天",
      calendar: "日历",
      stats: "统计",
      export: "导出",
      profile: "个人资料",
      logout: "退出登录",
    },
    moods: {
      very_happy: "非常开心",
      happy: "开心",
      neutral: "一般",
      sad: "难过",
      very_sad: "非常难过",
      angry: "生气",
      anxious: "焦虑",
      tired: "疲惫",
      in_love: "恋爱中",
      sick: "生病",
      surprised: "惊讶",
      relaxed: "放松",
      sporty: "运动",
      forgiven: "释然",
    },
    stats: {
      totalEntries: "总记录数",
      averageMood: "平均值",
      currentStreak: "当前连续",
      mostCommon: "最常见",
      days: "天",
    },
    chat: {
      searchUsers: "搜索用户...",
      noConversations: "暂无对话",
      startChat: "搜索用户开始聊天",
      typeMessage: "输入消息...",
      notAvailable: "隐身模式下聊天不可用",
      loginRequired: "使用谷歌或MoodPunk登录以聊天",
    },
    chatbot: {
      greeting: "你好！我是MoodBot，您的情绪健康助手。今天感觉如何？我在这里倾听您。",
      suggestion1: "我感觉很好",
      suggestion2: "我需要聊聊",
      suggestion3: "你能做什么？",
      typing: "MoodBot正在输入...",
      placeholder: "输入消息...",
      clearHistory: "历史已清除",
      assistant: "您的情绪助手",
    },
    common: {
      loading: "加载中...",
      error: "错误",
      success: "成功",
      cancel: "取消",
      confirm: "确认",
      save: "保存",
      delete: "删除",
      edit: "编辑",
      close: "关闭",
      today: "今天",
      yesterday: "昨天",
      now: "现在",
    },
  },
  
  pt: {
    login: {
      title: "MOODPUNK",
      subtitle: "Seu companheiro de bem-estar emocional",
      incognito: "MODO ANÔNIMO",
      incognitoDesc: "Sem registro, dados locais",
      google: "GOOGLE",
      googleDesc: "Sincronizar entre dispositivos",
      moodpunk: "MOODPUNK",
      moodpunkDesc: "Crie sua conta única",
      or: "ou entre com",
      email: "Email",
      password: "Senha",
      name: "Nome",
      login: "Entrar",
      register: "Registrar",
      noAccount: "Não tem conta?",
      hasAccount: "Já tem conta?",
      createAccount: "Criar conta",
      loginHere: "Entre aqui",
      selectLanguage: "Selecione seu idioma",
      usersJoined: "usuários registrados",
    },
    dashboard: {
      howFeeling: "Como você está se sentindo agora?",
      sync: "Sincronizar",
      syncing: "Sincronizando...",
      recentMoods: "Registros Recentes",
      noMoods: "Sem registros ainda",
      addNote: "Adicionar nota (opcional)...",
      save: "Salvar",
      delete: "Excluir",
      share: "Compartilhar",
    },
    nav: {
      dashboard: "Painel",
      chat: "Chat",
      calendar: "Calendário",
      stats: "Estatísticas",
      export: "Exportar",
      profile: "Perfil",
      logout: "Sair",
    },
    moods: {
      very_happy: "Muito Feliz",
      happy: "Bem",
      neutral: "Neutro",
      sad: "Triste",
      very_sad: "Muito Triste",
      angry: "Com Raiva",
      anxious: "Ansioso",
      tired: "Cansado",
      in_love: "Apaixonado",
      sick: "Doente",
      surprised: "Surpreso",
      relaxed: "Relaxado",
      sporty: "Esportivo",
      forgiven: "Perdoado",
    },
    stats: {
      totalEntries: "Total de Registros",
      averageMood: "Média",
      currentStreak: "Sequência Atual",
      mostCommon: "Mais Comum",
      days: "dias",
    },
    chat: {
      searchUsers: "Buscar usuários...",
      noConversations: "Sem conversas ainda",
      startChat: "Busque usuários para começar a conversar",
      typeMessage: "Digite uma mensagem...",
      notAvailable: "Chat não disponível no modo anônimo",
      loginRequired: "Entre com Google ou MoodPunk para conversar",
    },
    chatbot: {
      greeting: "Olá! Sou o MoodBot, seu assistente de bem-estar emocional. Como você está se sentindo hoje? Estou aqui para ouvir.",
      suggestion1: "Estou bem",
      suggestion2: "Preciso conversar",
      suggestion3: "O que você pode fazer?",
      typing: "MoodBot está digitando...",
      placeholder: "Digite uma mensagem...",
      clearHistory: "Histórico limpo",
      assistant: "Seu assistente emocional",
    },
    common: {
      loading: "Carregando...",
      error: "Erro",
      success: "Sucesso",
      cancel: "Cancelar",
      confirm: "Confirmar",
      save: "Salvar",
      delete: "Excluir",
      edit: "Editar",
      close: "Fechar",
      today: "Hoje",
      yesterday: "Ontem",
      now: "Agora",
    },
  },

  // Italian
  it: {
    login: {
      title: "MOODPUNK",
      subtitle: "Il tuo compagno di benessere emotivo",
      incognito: "MODALITÀ INCOGNITO",
      incognitoDesc: "Senza registrazione, dati locali",
      google: "GOOGLE",
      googleDesc: "Sincronizza tra dispositivi",
      moodpunk: "MOODPUNK",
      moodpunkDesc: "Crea il tuo account unico",
      or: "o accedi con",
      email: "Email",
      password: "Password",
      name: "Nome",
      login: "Accedi",
      register: "Registrati",
      noAccount: "Non hai un account?",
      hasAccount: "Hai già un account?",
      createAccount: "Crea account",
      loginHere: "Accedi qui",
      selectLanguage: "Seleziona la tua lingua",
      usersJoined: "utenti registrati",
    },
    dashboard: {
      howFeeling: "Come ti senti in questo momento?",
      sync: "Sincronizza",
      syncing: "Sincronizzando...",
      recentMoods: "Registri Recenti",
      noMoods: "Nessun registro ancora",
      addNote: "Aggiungi una nota (opzionale)...",
      save: "Salva",
      delete: "Elimina",
      share: "Condividi",
    },
    nav: {
      dashboard: "Dashboard",
      chat: "Chat",
      calendar: "Calendario",
      stats: "Statistiche",
      export: "Esporta",
      profile: "Profilo",
      logout: "Esci",
    },
    moods: {
      very_happy: "Molto Felice",
      happy: "Bene",
      neutral: "Neutrale",
      sad: "Triste",
      very_sad: "Molto Triste",
      angry: "Arrabbiato",
      anxious: "Ansioso",
      tired: "Stanco",
      in_love: "Innamorato",
      sick: "Malato",
      surprised: "Sorpreso",
      relaxed: "Rilassato",
      sporty: "Sportivo",
      forgiven: "Perdonato",
    },
    stats: {
      totalEntries: "Totale Registri",
      averageMood: "Media",
      currentStreak: "Serie Attuale",
      mostCommon: "Più Frequente",
      days: "giorni",
    },
    chat: {
      searchUsers: "Cerca utenti...",
      noConversations: "Nessuna conversazione ancora",
      startChat: "Cerca utenti per iniziare a chattare",
      typeMessage: "Scrivi un messaggio...",
      notAvailable: "Chat non disponibile in modalità incognito",
      loginRequired: "Accedi con Google o MoodPunk per chattare",
    },
    chatbot: {
      greeting: "Ciao! Sono MoodBot, il tuo assistente di benessere emotivo. Come ti senti oggi? Sono qui per ascoltarti.",
      suggestion1: "Mi sento bene",
      suggestion2: "Ho bisogno di parlare",
      suggestion3: "Cosa puoi fare?",
      typing: "MoodBot sta scrivendo...",
      placeholder: "Scrivi un messaggio...",
      clearHistory: "Cronologia cancellata",
      assistant: "Il tuo assistente emotivo",
    },
    common: {
      loading: "Caricamento...",
      error: "Errore",
      success: "Successo",
      cancel: "Annulla",
      confirm: "Conferma",
      save: "Salva",
      delete: "Elimina",
      edit: "Modifica",
      close: "Chiudi",
      today: "Oggi",
      yesterday: "Ieri",
      now: "Adesso",
    },
  },

  // Slovenian
  sl: {
    login: {
      title: "MOODPUNK",
      subtitle: "Vaš spremljevalec čustvenega počutja",
      incognito: "ANONIMNI NAČIN",
      incognitoDesc: "Brez registracije, lokalni podatki",
      google: "GOOGLE",
      googleDesc: "Sinhroniziraj med napravami",
      moodpunk: "MOODPUNK",
      moodpunkDesc: "Ustvari svoj edinstven račun",
      or: "ali se prijavi z",
      email: "E-pošta",
      password: "Geslo",
      name: "Ime",
      login: "Prijava",
      register: "Registracija",
      noAccount: "Nimaš računa?",
      hasAccount: "Že imaš račun?",
      createAccount: "Ustvari račun",
      loginHere: "Prijavi se tukaj",
      selectLanguage: "Izberi svoj jezik",
      usersJoined: "registriranih uporabnikov",
    },
    dashboard: {
      howFeeling: "Kako se počutiš zdaj?",
      sync: "Sinhroniziraj",
      syncing: "Sinhroniziranje...",
      recentMoods: "Nedavni Zapisi",
      noMoods: "Še ni zapisov",
      addNote: "Dodaj opombo (neobvezno)...",
      save: "Shrani",
      delete: "Izbriši",
      share: "Deli",
    },
    nav: {
      dashboard: "Nadzorna plošča",
      chat: "Klepet",
      calendar: "Koledar",
      stats: "Statistika",
      export: "Izvozi",
      profile: "Profil",
      logout: "Odjava",
    },
    moods: {
      very_happy: "Zelo Srečen",
      happy: "Dobro",
      neutral: "Nevtralno",
      sad: "Žalosten",
      very_sad: "Zelo Žalosten",
      angry: "Jezen",
      anxious: "Anksiozen",
      tired: "Utrujen",
      in_love: "Zaljubljen",
      sick: "Bolan",
      surprised: "Presenečen",
      relaxed: "Sproščen",
      sporty: "Športen",
      forgiven: "Odpuščen",
    },
    stats: {
      totalEntries: "Skupno Zapisov",
      averageMood: "Povprečje",
      currentStreak: "Trenutni Niz",
      mostCommon: "Najpogostejši",
      days: "dni",
    },
    chat: {
      searchUsers: "Išči uporabnike...",
      noConversations: "Še ni pogovorov",
      startChat: "Poišči uporabnike za začetek klepeta",
      typeMessage: "Napiši sporočilo...",
      notAvailable: "Klepet ni na voljo v anonimnem načinu",
      loginRequired: "Prijavi se z Google ali MoodPunk za klepet",
    },
    chatbot: {
      greeting: "Zdravo! Sem MoodBot, tvoj pomočnik za čustveno počutje. Kako se počutiš danes? Tu sem, da te poslušam.",
      suggestion1: "Počutim se dobro",
      suggestion2: "Moram se pogovoriti",
      suggestion3: "Kaj zmoreš?",
      typing: "MoodBot piše...",
      placeholder: "Napiši sporočilo...",
      clearHistory: "Zgodovina izbrisana",
      assistant: "Tvoj čustveni pomočnik",
    },
    common: {
      loading: "Nalaganje...",
      error: "Napaka",
      success: "Uspeh",
      cancel: "Prekliči",
      confirm: "Potrdi",
      save: "Shrani",
      delete: "Izbriši",
      edit: "Uredi",
      close: "Zapri",
      today: "Danes",
      yesterday: "Včeraj",
      now: "Zdaj",
    },
  },
};

// Language names for selector
export const languageNames = {
  es: { name: "Español", flag: "🇪🇸" },
  en: { name: "English", flag: "🇬🇧" },
  it: { name: "Italiano", flag: "🇮🇹" },
  sl: { name: "Slovenščina", flag: "🇸🇮" },
  pt: { name: "Português", flag: "🇧🇷" },
  fr: { name: "Français", flag: "🇫🇷" },
  de: { name: "Deutsch", flag: "🇩🇪" },
  zh: { name: "中文", flag: "🇨🇳" },
};

export const defaultLanguage = "es";
